import React from 'react';

import { observer } from 'mobx-react';

import { DEFAULT_TIME_FORMAT } from 'core/constants';

import { formatMoment } from 'utils/formatters/timezone';

import { EntityHistoryResponseType } from 'utils/api/modules/entities/entities.types';

import ClampedText from 'components/ClampedText';

import { HistoryText } from './styles';

const HistoryRow = ({
  item: { entityField, createdAt },
  children,
}: {
  item: EntityHistoryResponseType;
  children: React.ReactNode;
}): React.ReactElement => (
  <div
    key={`${entityField}-${createdAt}`}
    style={{
      gap: '8px',
      display: 'flex',
      alignItems: 'center',
      borderRadius: '8px',
    }}
  >
    <p style={{ fontSize: '12px' }} data-testid="history-entry-time">
      {formatMoment(createdAt, DEFAULT_TIME_FORMAT)}
    </p>
    <svg
      style={{ flexShrink: 0 }}
      xmlns="http://www.w3.org/2000/svg"
      width="4"
      height="4"
      fill="none"
      viewBox="0 0 4 4"
    >
      <circle cx="2" cy="2" r="2" fill="#757575" />
    </svg>
    <HistoryText>
      <ClampedText>{children}</ClampedText>
    </HistoryText>
  </div>
);

export default observer(HistoryRow);
